<template>
    <div class="container">
        <div class="inner-container">
            <div style="position:absolute;top: 300px;left: 300px;">
                <div>
                    <image-dragger ref="imageDragger" :picUrl="src">
                        <div class="block"></div>
                    </image-dragger>
                </div>
            </div>
            <button type="button" @click="buttonClickHandler">
                获得url
            </button>
            <div>
                结果：
                <div>
                    {{url}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImageDragger from '@/components/ImageDragger';
    export default {
        name: "Demo",
        components: {ImageDragger},
        data() {
            return {
                src: 'http://wxtestfilebucket-10048617.picsh.myqcloud.com/activity/1611561179714/1.jpg',
                url: ''
            }
        },
        methods: {
            buttonClickHandler() {
                this.url = this.$refs.imageDragger.getUrl();
            }
        }
    }
</script>

<style scoped>
    .container {
        margin-left: 100px;
        margin-top: 100px;
        overflow-y: auto;
        height: 700px;
    }
    .inner-container {
        height: 1000px;
    }
.block {
    width: 50px;
    height: 50px;
    background-color: #0c80fe;
}
</style>



// WEBPACK FOOTER //
// src/views/Demo.vue